import axios from "./axios"
const basePath = '/protected/api/v1/vehDriApplication/hzmb';

/**
 * 檢查服務准入條件
 * @param {*} serviceType 
 * @param {*} changeType 
 * @param {*} identType 
 * @param {*} identNo 
 * @param {*} spNo 
 * @param {*} isFirst 
 * @param {*} registrationNo 
 * @param {*} identificationNo 
 * @returns 
 */
const check = ({
  serviceType,
  changeType,
  identType,
  identNo,
  spNo,
  isFirst,
  registrationNo,
  identificationNo,
}) => {
  return axios.post(`${basePath}/${serviceType}`, null, {
    params: {
      changeType,
      identType,
      identNo,
      spNo,
      isFirst,
      registrationNo,
      identificationNo,
    }
  }).then((res) => res.data);
}

/**
 * 補交文件
 * @param {*} serviceType 
 * @param {*} applicationId 
 */
const supplement = (serviceType, applicationId,) => {
  return axios.post(`${basePath}/${serviceType}/${applicationId}/supplement`)
}

/**
 * 刪除文件
 * @param {*} serviceType 
 * @param {*} applicationId 
 * @param {*} id 
 * @returns 
 */
const delFile = (serviceType, applicationId, id) => {
  return axios.delete(`${basePath}/delete/file/${serviceType}/${applicationId}/${id}`).then(res => res.data)
}

/**
 * 查詢申請資料
 * @param {*} applicationId 
 * @returns 
 */
const detail = (applicationId) => {
  return axios.get(`${basePath}/detail`, { params: { applicationId } }).then(res => res.data)
}

/**
 * 下載文件
 * @param {*} serviceType 
 * @param {*} applicationId 
 * @param {*} id 
 * @returns 
 */
const downloadFile = (serviceType, applicationId, id) => {
  return axios.get(`${basePath}/download/file/${serviceType}/${applicationId}/${id}`, {
    responseType: 'blob'
  }).then(res => res)
}

/**
 * 下載文件縮略圖
 * @param {*} serviceType 
 * @param {*} applicationId 
 * @param {*} id 
 * @returns 
 */
const downloadThumbFile = (serviceType, applicationId, id) => {
  return axios.get(`${basePath}/download/thumb/file/${serviceType}/${applicationId}/${id}`, {
    responseType: 'blob'
  }).then(res => res)
}

/**
* 暫存申請文件
* @param {*} id 
* @param {*} file 
* @param {*} fileValues 
* @returns 
*/
const saveFile = (serviceType, applicationId, file, fileValue) => {
  let formData = new FormData();
  formData.append("file", file);
  formData.append(
    "fileValue",
    new Blob([JSON.stringify(fileValue)], {
      type: "application/json",
    })
  );
  return axios.post(`${basePath}/file/${serviceType}/${applicationId}`, formData).then(res => res.data)
}


/**
 * 提交申請
 * @param {*} form 
 * @param {*} files 
 * @param {*} fileValues 
 */
const first = (form) => {
  let formData = new FormData();
  const { applicationId } = form;
  formData.append("applicationId", applicationId);
  return axios.post(`${basePath}/first`, formData).then(res => res.data)
}

/**
* 獲取通知訊息
* @param {*} id 
* @param {*} serviceType 
* @param {*} messageType 
* @param {*} parameters 
*/
const message = (id, serviceType, messageType, parameters = {}) => {
  return axios.post(`${basePath}/preview-message?serviceType=${serviceType}&messageType=${messageType}${id ? `&id=${id}` : ''}`, parameters).then(res => res.data)
}

/**
 * 暫存申請
 * @param {*} form 
 * @returns 
 */
const save = ({ drivers, id, language, quota, renew, serviceType, spNo, vehicle, quotaInfoToDri, changeType }) => {
  return axios.post(`${basePath}/save/first`, {
    drivers, id, language, quota, renew, serviceType, spNo, vehicle, quotaInfoToDri, changeType
  }).then(res => res.data)
}

/**
 * 查詢申請資料
 * @param {*} applicationId 
 * @returns 
 */
const findById = (applicationId) => {
  return axios.get(`${basePath}/detail/${applicationId}`).then(res => res.data)
}

/**
 * 暫存補交文件
 * @param {*} serviceType 
 * @param {*} applicationId 
 * @param {*} file 
 * @param {*} fileValue 
 * @returns 
 */
const saveSupplementFile = (serviceType, applicationId, file, fileValue) => {
  let formData = new FormData();
  formData.append("file", file);
  formData.append(
    "fileValue",
    new Blob([JSON.stringify(fileValue)], {
      type: "application/json",
    })
  );
  return axios.post(`${basePath}/supplement/file/${serviceType}/${applicationId}`, formData).then(res => res.data)
}

/**
 * 查詢換人換車文件類型
 * @param {*} applicationId 
 * @returns 
 */
const getDocuments = (applicationId) => {
  return axios.get(`${basePath}/documents/${applicationId}`).then(res => res.data)
}

/**
 * 動態下載文件
 * @param {*} applicationId 
 * @param {*} documentTypeId 
 * @returns 
 */
const dynamicDownload = (applicationId, documentTypeId) => {
  return axios.get(`${basePath}/dynamic-download-document/${applicationId}/${documentTypeId}`, {
    responseType: 'blob'
  }).then(res => res)
}

/**
 * 提交
 * @param {*} applicationId 
 * @returns 
 */
const submit = (applicationId) => {
  return axios.post(`${basePath}/submit/${applicationId}`).then(res => res.data)
}

export default {
  check,
  supplement,
  delFile,
  detail,
  downloadFile,
  downloadThumbFile,
  saveFile,
  first,
  message,
  save,
  findById,
  saveSupplementFile,
  getDocuments,
  dynamicDownload,
  submit,
}